import { serverTime } from "@Engage.Core";
export class Http {
    get(url, payload, options) {
        return this.call('GET', url, payload, options);
    }
    post(url, payload, options) {
        return this.call('POST', url, payload, options);
    }
    async call(method, url, payload, options = {}) {
        var _a, _b;
        const fetchURL = new URL(url);
        const fetchOptions = { method };
        const headers = new Headers((_a = options.headers) !== null && _a !== void 0 ? _a : {});
        headers.set('Content-Type', (_b = options.contentType) !== null && _b !== void 0 ? _b : 'application/json');
        headers.set('Accept', 'application/json');
        fetchOptions.headers = headers;
        if (method === 'GET') {
            if (payload) {
                Object.keys(payload).forEach(key => fetchURL.searchParams.append(key, payload[key]));
            }
        }
        else {
            fetchOptions.body = JSON.stringify(payload);
        }
        if (options.cache === false && !fetchURL.searchParams.has('_')) {
            fetchURL.searchParams.append('_', Date.now().toString());
        }
        const response = await fetch(fetchURL.href, fetchOptions);
        serverTime.setOffset(response.headers.get(serverTime.header));
        if (!response.ok) {
            if (response.status === 404 || response.status === 500) {
                throw { ErrorMessage: `${response.status} - ${response.url}. ${response.statusText}` };
            }
            const text = await response.text();
            throw text ? JSON.parse(text) : {};
        }
        const text = await response.text();
        return text ? JSON.parse(text) : {};
    }
}
